// __webpack_public_path__ = window.WEBPACK_PUBLIC_PATH || '';

import { createApp } from 'vue';
import App from './univstudy/App.vue';
import router from './univstudy/router';
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

const app = createApp(App);

// FloatingVue configuration
app.use(FloatingVue, {
    themes: {
        tooltips: {
            '$extend': 'menu',
            '$resetCss': true,
            triggers: ['hover', 'focus', 'click', 'touchend'],
            hideTriggers: ['hover', 'focusout', 'click', 'blur', 'scroll', 'touchmove'],
            popperTriggers: ['hover', 'focus', 'focusin', 'click', 'touchend'],
            autoHide: false,
            hideOnClick: true,
            placement: 'top',
            distance: 8,
            html: true,
            preventOverflow: true,
            delay: {
                show: 100,
                hide: (event) => event.type === 'touchend' ? 2000 : 0,
            },
            disposeTimeout: 100,
        },
    },
});

app.use(router);
app.mount('#univstudy-vue-app');
